import { format } from "date-fns";

export const FORMATTER_OPTIONS = {
  log: "MM/dd/yyyy - kk:mm:ss",
  player_table: "MMM d, p",
  match_table: "MMM d, p",
  log_sec: "kk:mm:ss",
};

export const dateFormatter = (date: Date, formatter: string): string =>
  format(new Date(date), formatter);

export const fromSecondsToMMSS = (seconds: number) => {
  // Minutes and seconds
  const mins = ~~((seconds % 3600) / 60);
  const secs = ~~seconds % 60;

  // Output like "1:01".
  let result = "";
  result += "" + mins + ":" + (secs < 10 ? "0" : "");
  result += "" + secs;
  return result;
};
